import { Injectable } from "@angular/core";

import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams, HttpErrorResponse } from "@angular/common/http";

import { Quote, CacheService } from '@mapfre-tech/amap3';
import * as _ from 'lodash';
import { map, catchError } from "rxjs/operators";
import { Observable, throwError } from "rxjs";

@Injectable({
   providedIn: "root"
})
export class QuoteDayService {

   className = 'QuoteDayService';

   constructor(private http: HttpClient, private cacheService: CacheService) { }

   getAllQuotes(): Observable<Quote[]> {
      return this.http.get<Quote[]>(environment.base_URL + "/celebrated-sentence");
   }

   newQuote(newQuote: Quote) {
      return this.http.post(environment.base_URL + "/celebrated-sentence", newQuote)
   }

   updateQuote(editedQuote, id) {
      return this.http.put(environment.base_URL + `/celebrated-sentence/${id}`, editedQuote)
   }

   deleteQuote(sentenceId) {
      return this.http.delete(environment.base_URL + `/celebrated-sentence/${sentenceId}`)
   }

   getRandomQuote(cache = true, cacheKey = "quoteRandom"): Observable<any> {
      const params: any = {
         dailySentence: true
      }
      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey);
       } else {
         const observable = this.http.get(environment.base_URL + "/celebrated-sentence", { params }).pipe(map((res) => {
         this.cacheService.updateCacheData(res, cacheKey)
         return res;
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
       }
   }

}
